import React from 'react';
import CardHeader from './card-header';
import CardContent from './card-content';
import { Mobile } from '../../app-responsive';
import { HERO } from '../../app-constants';

const isHero = (content) => {
  let hero = false;
  if (content) {
    const { data } = content;
    const { layoutMode } = data;
    hero = layoutMode === HERO;
  }
  return hero;
};

const GenericCard = (props) => {
  const { cardClass = '', headerComponent, contentComponent, footerComponent, headerTitle, headerDescription, content, cardBodyClass = '' } = props;

  // default headerContent
  let headerContent = <div className="card-header" role="tab">{headerComponent}</div>;
  // title headerContent
  headerContent = headerTitle ? <CardHeader title={headerTitle} /> : headerContent;
  // title and description
  headerContent = headerTitle && headerDescription ? <CardHeader title={headerTitle} description={headerDescription} /> : headerContent;
  // metaData headerContent
  headerContent = content && content.metaData ? <CardHeader metaContent={content} /> : headerContent;
  // if hero exclude header
  headerContent = isHero(content) ? <Mobile>{headerContent}</Mobile> : headerContent;
  const blockContent = content
    ? <CardContent values={content} cardBodyClass={cardBodyClass} />
    : <div className={`${cardBodyClass} mbs_card-body`}>{contentComponent}</div>;
  return (
    <div className={`card ${cardClass}`}>
      {headerContent}
      {blockContent}
      {footerComponent}
    </div>
  );
};


export default GenericCard;
